import { connect } from 'react-redux';
import Info from './info';
import { closePanel } from '../../actions/panel';
import { removeFromCanvas, updateAttributes } from '../../actions/canvas';
import { addToCart, addWallGroupToCart } from '../../actions/cart';
import { panelGroups } from '../../selectors/pricing';

// `updateAttributes` and `name` are never named inside Info — they reach <Title> through
// its `...rest`. Removing either from here breaks wall-title editing at runtime, and there
// is no Jest to catch it.
const mapStateToProps = (state) => {
  const {
    canvas: {
      name, currency, works
    }
  } = state;

  return {
    groups: panelGroups(state),
    // renderWork and removeFromCanvas address items by their index in canvas.works,
    // which grouping reorders — map back through the identity of the work object.
    indexOf: (work) => works.findIndex((w) => (
      work.wallPictureId ? w.wallPictureId === work.wallPictureId : w.key === work.key
    )),
    name,
    currency
  };
};

export default connect(mapStateToProps, {
  removeFromCanvas, closePanel, addToCart, updateAttributes, addWallGroupToCart
})(Info);
